import { render, staticRenderFns } from "./AlbumPage.vue?vue&type=template&id=25c5f377&lang=pug&"
import script from "./AlbumPage.vue?vue&type=script&lang=js&"
export * from "./AlbumPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports